module.exports = { "default": require("core-js/library/fn/object/define-property"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-runtime/core-js/object/define-property.js
// module id = 318
// module chunks = 2